import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const activityDocumentRelationDataClassName =
  DataClassName.ACTIVITY_DOCUMENT_RELATION
const activityDocumentRelationEndpoint = PisaDataClassEndpoint.ACTIVITY_DOCUMENT

export function pisaActivityDocumentRelationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(activityDocumentRelationDataClassName, {
    title: activityDocumentRelationDataClassName,
    restApi: createPisaRestApiConfig(activityDocumentRelationEndpoint),
    attributes,
  })
}
